import { Link } from "@inertiajs/react";
import { ChevronRight } from "lucide-react";
import styled from "styled-components";

const Nav = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 13px;
  color: #8a8f9c;
`;

const Crumb = styled(Link)`
  color: #5e6278;
  text-decoration: none;

  &:hover {
    color: #c9a961;
  }
`;

const Current = styled.span`
  color: #1a1a1a;
  font-weight: 600;
`;

const Breadcrumb = ({ items }) => {
  return (
    <Nav aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span
            key={item.href || item.label}
            style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
          >
            {isLast || !item.href ? (
              <Current>{item.label}</Current>
            ) : (
              <Crumb href={item.href}>{item.label}</Crumb>
            )}
            {!isLast ? <ChevronRight size={14} /> : null}
          </span>
        );
      })}
    </Nav>
  );
};

export default Breadcrumb;
